markResult